import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/style/index.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'nepali-datepicker-reactjs/dist/index.css';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import store from './store/store';
import VoucherEntryContext from './context/VoucherEntryContext';
import { TimeZoneProvider } from './context/TimeZoneProvider';
import { ClockProvider } from './context/ClockProvider';
import BillinEntryContext from './context/BillinEntryContext';
import { LanguageProvider } from './context/LanguageProvider';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LanguageProvider>
        <ClockProvider>
          <TimeZoneProvider>
            <BillinEntryContext>
              <VoucherEntryContext>
                <Toaster />
                <App />
              </VoucherEntryContext>
            </BillinEntryContext>
          </TimeZoneProvider>
        </ClockProvider>
      </LanguageProvider>
    </Provider>
  </React.StrictMode>
);
